import urljoin from "url-join";

const env = {
  development: process.env.NODE_ENV === "development",
  production: process.env.NODE_ENV === "production",
};

const backend = {
  AUTH_URI: process.env.REACT_APP_SERVER_URI,
  HTTP_URI: urljoin(process.env.REACT_APP_SERVER_URI ?? "", "graphql"),
  WS_URI: process.env.REACT_APP_WS_URI,
  CHATBOT_URI: process.env.REACT_APP_CHATBOT_URI,
  ULTRAMSG_URL: process.env.REACT_APP_ULTRAMSG_URL,
  CHATBOT_TABLE: urljoin(
    process.env.REACT_APP_SERVER_URI ?? "",
    "chatbot_table"
  ),
};

const localURL = process.env.REACT_APP_LOCAL_URL;

const publicNamespace = process.env.REACT_APP_PUBLIC_NAMESPACE;

const elevenlabs = {
  API_KEY: process.env.REACT_APP_ELEVENLABS_API_KEY,
  VOICE_ID: process.env.REACT_APP_ELEVENLABS_VOICE_ID,
  MODEL_ID: process.env.REACT_APP_ELEVENLABS_MODEL_ID,
};

const zoom = {
  CLIENT_ID: process.env.REACT_APP_ZOOM_CLIENT_ID || "J_swGmNbRe29Wv0hmfAztw",
  REDIRECT_URI: `${localURL}/integrations/zoom`,
  CLIENT_SECRET: process.env.REACT_APP_ZOOM_CLIENT_SECRET,
};

export { env, backend, publicNamespace, localURL, elevenlabs, zoom };
